export default "__VITE_ASSET__JM2$I5bI__"